import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { backofficePath } from "./backoffice/backoffice_path";

export default class extends Controller {
  static targets = ["list"];
  static values = { pageId: String };

  connect() {
    const scope = this;
    for (var i = 0; i < this.listTargets.length; i++) {
      new Sortable(this.listTargets[i], {
        handle: '.move',
        group: 'nested',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        onEnd: (event) => scope.onSort(event),
      });
    };
  };

  onSort(event) {
    const allItems = event.to.children;

    const columns = {};
    for (let i = 0; i < allItems.length; i++) {
      const item = allItems[i];
      columns[item.dataset.columnId] = i;
    };

    fetch(backofficePath(`/pages/${this.pageIdValue}/rows/${event.to.dataset.rowId}/columns/sort`), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ column_id: event.item.dataset.columnId, columns: columns })
    });

    window.dispatchEvent(new CustomEvent('preview:sort'));
  };
};
